import { Field, Form, Formik } from 'formik';
import { InputType } from '../../../Common/FormFields/InputType';
import { DropDown } from '../../../Common/FormFields/DropDown';
import RoundButton from '../../../Common/RoundButton';
import BankDetails from './bankDetails';
import ErrorMessage from '../../../Common/ErrorMessage';
import { useState } from 'react';
import PaymentSafe from '../../../utils/assests/payment-safe.png';
import { Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import { ERROR_MESSAGE_TRUE } from '../../../utils/placeHolderString';
export default function ConnectBankForm({
  initialValues,
  validationSchema,
  onSubmitHandle,
  onChangeField,
  ifscData,
  blurHandler,
  connectFetchKycError,
  error,
  accountTypeData,
  errorMessage,
  formikRef,
  enterKeyPress,
  ifscError,
}: // ifscAccess,
// accountNumberAccess,
// accountTypeAccess
any) {
  const [message, setMessage] = useState<string>('');
  const accessed = () => {
    setMessage(ERROR_MESSAGE_TRUE);
  };
  const NotAccessible = () => {};
  return (
    <>
      <Formik
        validateOnMount={true}
        innerRef={formikRef}
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(value) => onSubmitHandle(value)}
      >
        {({ handleSubmit, values, touched, errors }) => (
          <Form>
            <div>
              <Field
                component={InputType}
                type='number'
                placeholder='account no'
                name='accountNumber'
                value={values.accountNumber}
                onChange={onChangeField}
                maxLength={20}
                onKeyPress={enterKeyPress}
                // readOnly={accountNumberAccess}
                // className= {accountNumberAccess === true ? 'readOnly': ''}
                // onClick={accountNumberAccess === true ? () => accessed(): ()=>NotAccessible()}
                className='withIcon inputUser'
              />
              {/* <Field
                component={InputType}
                type='number'
                placeholder='confirm account no'
                name='confirmAccountNumber'
                value={values.confirmAccountNumber}
                onChange={onChangeField}
                maxLength={20}
                onKeyPress={enterKeyPress}
                // readOnly={readOnly}
                // className= {readOnly === true ? 'readOnly': ''}
                className='withIcon inputUser'
              /> */}
              <div className='inputSelectAcountType'>
                <Field
                  component={DropDown}
                  placeholder='account type'
                  name='accountType'
                  value={values.accountType}
                  onChange={onChangeField}
                  Data={accountTypeData}
                  onKeyPress={enterKeyPress}
                  // readOnly={accountTypeAccess}
                  // className= {accountTypeAccess === true ? 'readOnly': ''}
                  // onClick={accountTypeAccess === true ? () => accessed(): ()=>NotAccessible()}
                  className='withIcon inputAadhar'
                />
              </div>

              <Field
                component={InputType}
                type='text'
                placeholder='IFSC code'
                name='ifscCode'
                value={values.ifscCode?.toUpperCase()}
                onChange={onChangeField}
                onBlur={blurHandler}
                maxLength={20}
                onKeyPress={enterKeyPress}
                // readOnly={ifscAccess}
                // className= {ifscAccess === true ? 'readOnly': ''}
                // onClick={ifscAccess === true ? () => accessed(): ()=>NotAccessible()}
                className='withIcon inputPincode'
              />

              <ErrorMessage text={errorMessage} />
            </div>
            {ifscData?.error && <ErrorMessage text={ifscData?.error} />}
            {ifscData?.BRANCH && <BankDetails ifscData={ifscData} />}
            {error && <ErrorMessage text={error} />}
            {connectFetchKycError === 'Internal Server Error' ? (
              <ErrorMessage text={'CKYC info not found '} />
            ) : connectFetchKycError?.errors?.detail ? (
              <ErrorMessage text={connectFetchKycError?.errors?.detail} />
            ) : (
              <ErrorMessage text={connectFetchKycError} />
            )}
            <Box className='bottomImgAndText'>
              <img src={PaymentSafe} alt='' />
              <Typography
                variant='h2'
                className='text-center fs-20 fw-400 text-gray-four'
              >
                Your account details <br /> will remain secure with us
              </Typography>
            </Box>
            <Box sx={{ mt: 4, mb: 2 }}>
              <RoundButton title='Proceed for okyc' type='submit' />
            </Box>
          </Form>
        )}
      </Formik>
    </>
  );
}
